import { BaseDrawOption } from '@/modules/ta/legacy/widget/models/drawoptions/BaseDrawOption';
import { PlotType } from '@/modules/ta/legacy/widget/widget.constants';

export class GeoChartDrawOption extends BaseDrawOption {
  /**
   * @type {string}
   */
  plot_type;

  /**
   * @type {boolean}
   */
  has_tooltip;

  auto_zoom;

  auto_zoom_threshold;

  constructor(model = {}) {
    super(model);

    this.auto_zoom = model.auto_zoom ?? false;
    this.auto_zoom_threshold = model.auto_zoom_threshold ?? 90;

    this.setValidPlotType(model);
  }

  setValidPlotType(model) {
    const validTypes = [
      PlotType.BUBBLE_MAP,
      PlotType.HEAT_MAP,
      PlotType.HEAT_MAP_V2,
      PlotType.BUBBLE_MAP_V2,
    ];

    if (!validTypes.includes(model.plot_type)) {
      this.plot_type = PlotType.BUBBLE_MAP_V2;
    }
    this.plot_type = model.plot_type;
  }
}
